module.exports = __webpack_public_path__ + "img/face.00221137.png";